export const CHOOSE_PAYMENT_CONFIG_TOKEN = 'CHOOSE_PAYMENT_CONFIG_TOKEN';
export const CHOOSE_PAYMENT_NAVIGATION_TOKEN = 'CHOOSE_PAYMENT_NAVIGATION_TOKEN';
export const MOBILE_ANALYTIC_TRACKER_TOKEN = 'MOBILE_ANALYTIC_TRACKER_TOKEN';
export const USERS_PROFILE_SERVICE_TOKEN = 'USERS_PROFILE_SERVICE_TOKEN';
